export const pickLocalizedField = (object, baseKey, language = "en") => {
  if (!object) return "";
  const preferredKey = `${baseKey}_${language === "fr" ? "fr" : "en"}`;
  const fallbackKey = `${baseKey}_${language === "fr" ? "en" : "fr"}`;
  return (
    object[preferredKey] ||
    object[baseKey] ||
    object[fallbackKey] ||
    ""
  );
};

export const localizedCategoryName = (category, language = "en") =>
  pickLocalizedField(category, "name", language);

export const localizedProductName = (product, language = "en") =>
  pickLocalizedField(product, "name", language);

export const localizedProductDescription = (product, language = "en") =>
  pickLocalizedField(product, "description", language);

export const localizedProductExtraInformation = (product, language = "en") =>
  pickLocalizedField(product, "extra_information", language);
